import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FilterPipe } from './filter.pipe';
import { MaskPipe } from './ssnMask.pipe';
import { TabFilterPipe } from './tab-filter.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { FormatNumberPipe } from './format-number.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [MaskPipe, FilterPipe, TabFilterPipe, SafeHtmlPipe,FormatNumberPipe],
  exports: [MaskPipe, FilterPipe, TabFilterPipe, SafeHtmlPipe,FormatNumberPipe],
  providers: [MaskPipe, FilterPipe, TabFilterPipe, SafeHtmlPipe,FormatNumberPipe]
})
export class SharedPipesModule {}
